import { defineStore } from 'pinia'
import { toast } from '@/components/primitives/AppToaster/toast'
import type { ToastType } from '@/components/primitives/AppToaster/toast-types'

export interface ToastActionInput {
  label: string
  run: () => void
}

export interface ShowToastInput {
  title: string
  description?: string
  tone?: ToastType
  /** One button on the toast, such as Undo; pressing it runs `run` and dismisses the toast. */
  action?: ToastActionInput
}

export const useToastStore = defineStore('toast', () => {
  function show(input: ShowToastInput): string {
    const id = crypto.randomUUID()
    toast(input.title, {
      id,
      description: input.description,
      type: input.tone ?? 'default',
      action: input.action && { label: input.action.label, onClick: input.action.run },
    })
    return id
  }

  function dismiss(id: string): void {
    toast.dismiss(id)
  }

  function success(title: string, description?: string): string {
    const id = crypto.randomUUID()
    toast.success(title, { id, description })
    return id
  }

  function error(title: string, description?: string): string {
    const id = crypto.randomUUID()
    toast.error(title, { id, description })
    return id
  }

  return { show, dismiss, success, error }
})
